export default __webpack_public_path__ + "static/media/tech_small.7a390e14.png";